import React from 'react'
import CapabilityList from './CapabilityList'
import ATTextButton from '../../../common/formComponent/ATTextButton'
import { MdOutlineInfo } from 'react-icons/md'
import { SelectCapabilitiesProps } from '../../../../utils/types/roles/RolesTypes'
import { useSelectCapabilities } from '../../../../customHooks/usermanagement/useSelectCapabilities'
import { useTranslation } from 'react-i18next'

const SelectCapabilities: React.FC<SelectCapabilitiesProps> = ({
  backButtonHandler,
  onCloseModal,
  onSaveHandler,
}) => {
  const { t } = useTranslation(['translation'])
  const {
    roleDetails,
    levelOneState,
    levelTwoState,
    levelThreeState,
    capabilitiesFinalResult,
    appCapabilities,
    isFeaturePresent,
    updateLevelOneActiveFeature,
    updateLevelTwoActiveFeature,
    handleLevelOneCheckboxSelection,
    handleLevelTwoCheckboxSelection,
    handleLevelThreeCheckboxSelection,
    getCheckboxDisableStatus,
  } = useSelectCapabilities()

  return (
    <div className="p-5 pt-2 pb-3">
      <div className="capability-container-border">
        <div className="row disc-block-bg p-2 m-0">
          <div className="col-md-5 col-12 flex-row">
            <p className="form-label mb-0">{t('user_management.role_name')}</p>
            <p className="stage-left-content ps-2 m-0">
              {roleDetails?.roleName}
            </p>
          </div>
          <div className="col-md-5 col-12 flex-row">
            <p className="form-label mb-0">
              {t('user_management.application_name')}
            </p>
            <p className="stage-left-content ps-2 m-0">
              {roleDetails?.application}
            </p>
          </div>
        </div>
        <div className="d-flex bg-white">
          {/* Level1 */}
          <div className="col-md-4 col-12 border-end">
            <CapabilityList
              options={levelOneState?.options}
              isFeatureChecked={(featureCode) =>
                isFeaturePresent(capabilitiesFinalResult, 1, featureCode)
              }
              handleSelection={handleLevelOneCheckboxSelection}
              activeFeature={levelOneState?.activeFeature}
              setActiveFeature={(featureCode) =>
                updateLevelOneActiveFeature(featureCode)
              }
              isLoading={appCapabilities?.isFetching}
              disabled={true}
              level={1}
              featureNameKey="featureGroupName"
              featureCodeKey="featureGroupCode"
            />
          </div>
          {/* Level 2 */}
          <div className="col-md-4 col-12 border-end">
            <CapabilityList
              options={levelTwoState?.options}
              isFeatureChecked={(featureCode) =>
                isFeaturePresent(capabilitiesFinalResult, 2, featureCode)
              }
              handleSelection={handleLevelTwoCheckboxSelection}
              activeFeature={levelTwoState?.activeFeature}
              setActiveFeature={(featureCode) =>
                updateLevelTwoActiveFeature(featureCode)
              }
              isLoading={appCapabilities?.isFetching}
              disabled={getCheckboxDisableStatus(
                1,
                levelOneState?.activeFeature,
              )}
              level={2}
              featureNameKey="featureName"
              featureCodeKey="featureCode"
            />
          </div>
          {/* Level 3 */}
          <div className="col-md-4 col-12">
            <CapabilityList
              options={levelThreeState?.options}
              isFeatureChecked={(featureCode) =>
                isFeaturePresent(capabilitiesFinalResult, 3, featureCode)
              }
              handleSelection={handleLevelThreeCheckboxSelection}
              isLoading={appCapabilities?.isFetching}
              disabled={getCheckboxDisableStatus(
                2,
                levelTwoState?.activeFeature,
              )}
              level={3}
              featureNameKey="capabilityName"
              featureCodeKey="capabilityCode"
            />
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center mt-2">
        <MdOutlineInfo size={14} />
        <span className="ps-1 select-capability-note">
          <strong>{`${t('common.note')}:`}</strong>{' '}
          {t('user_management.select_capability_note')}
        </span>
      </div>
      <div className="d-flex py-3 justify-content-end">
        <div>
          <ATTextButton
            title={t('common.cancel')}
            onPressHandler={onCloseModal}
            isFilledButton={false}
          />
        </div>
        <div>
          <ATTextButton
            title={t('common.back')}
            onPressHandler={backButtonHandler}
            isFilledButton={false}
            customClassName="text-uppercase"
          />
        </div>
        <div>
          <ATTextButton
            title={roleDetails?.isEdit ? t('common.update') : t('common.save')}
            onPressHandler={onSaveHandler}
            disabled={capabilitiesFinalResult?.length === 0}
            customClassName="text-uppercase"
          />
        </div>
      </div>
    </div>
  )
}

export default React.memo(SelectCapabilities)
